/*************************/
/****** Desktop Nav ******/ 
/*************************/

let burgerButton = document.querySelector(".ham-button");
let navbarSidePapa = document.querySelector("#papaNav");
let navbarSideFjallRaven = document.querySelector("#fjallravenNav");
let navbarSideMiir = document.querySelector("#miirNav");
let navbarSideIGS = document.querySelector("#spiritsNav");
let navbarSideTommys = document.querySelector("#tommysNav");
let body = document.querySelector("body");
let sideMenuOverlay = document.querySelector(".side-menu-overlay");
let accordionLevelTwo = document.querySelectorAll(".second-lvl a");
let accordionActive = document.querySelector(".accordion-menu-title.dropdown"); 


const menuItem1 = document.querySelector(".menu-item--1");
const menuItem2 = document.querySelector(".menu-item--2");
const menuItem3 = document.querySelector(".menu-item--3");
const menuItem4 = document.querySelector(".menu-item--4");
const menuItem5 = document.querySelector(".menu-item--5");
const menuItem6 = document.querySelector(".menu-item--6");
const menuItem7 = document.querySelector(".menu-item--7");
const menuItem8 = document.querySelector(".menu-item--8");
const menuItem9 = document.querySelector(".menu-item--9");
const menuItem10 = document.querySelector(".menu-item--10");
const menuItem11 = document.querySelector(".menu-item--11");
const menuItem12 = document.querySelector(".menu-item--12");
const tommysMenuItem1 = document.querySelector(".tommys--link-1");
const tommysMenuItem2 = document.querySelector(".tommys--link-2");
const tommysMenuItem3 = document.querySelector(".tommys--link-3");

const deepslideItem1 = document.querySelector(".deepslide-item--1");
const deepslideItem2 = document.querySelector(".deepslide-item--2");
const deepslideItem3 = document.querySelector(".deepslide-item--3");
const deepslideItem4 = document.querySelector(".deepslide-item--4");
const deepslideItem5 = document.querySelector(".deepslide-item--5");
const deepslideItem6 = document.querySelector(".deepslide-item--6");
const deepslideItem7 = document.querySelector(".deepslide-item--7");
const deepslideItem8 = document.querySelector(".deepslide-item--8");
const deepslideItem9 = document.querySelector(".deepslide-item--9");
const deepslideItem10 = document.querySelector(".deepslide-item--10");
const deepslideItem11 = document.querySelector(".deepslide-item--11");
const deepslideItem12 = document.querySelector(".deepslide-item--12");
const tommysMenu1 = document.querySelector(".tommys-menu-1");
const tommysMenu2 = document.querySelector(".tommys-menu-2");
const tommysMenu3 = document.querySelector(".tommys-menu-3");


  
const fjallRavenMenu = document.querySelector(".fjall-raven"); 
const miirMenu = document.querySelector(".miir"); 
const inGoodSpiritsMenu = document.querySelector(".in-good-spirits-co"); 
const tommysMenu = document.querySelector(".tommys"); 
const tommysBarMenu = document.querySelector(".tommys-bar-menu"); 
const tommysWhiskeyMenu = document.querySelector(".tommys-whiskey-menu"); 
const justLikePapa = document.querySelector(".justlikepapa"); 
const primus = document.querySelector(".primus"); 

/** OPEN RESPECTIVE BRAND PAGE MENUS **/
let sideMenu = () => {
    if (navbarSidePapa !== null) {
      navbarSidePapa.classList.toggle("awake") 
    } else if (navbarSideFjallRaven !== null) {
      navbarSideFjallRaven.classList.toggle("awake")
    } else if (navbarSideMiir !== null) {
      navbarSideMiir.classList.toggle("awake")  
    } else if (navbarSideIGS !== null) {
      navbarSideIGS.classList.toggle("awake") 
    } else if (navbarSideTommys !== null) {
      navbarSideTommys.classList.toggle("awake")  
    }; 

  /** CLOSE DEEPSLIDE MENU WHEN MAIN MENU CLOSED **/
    body.classList.toggle("awoken");
    if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
    if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
    if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
    if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
    if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
    if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
    if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
    if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
    if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
    if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
    if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
    if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
    if (tommysMenu1 !== null) { tommysMenu1.classList.remove("menu-open"); }
    if (tommysMenu2 !== null) { tommysMenu2.classList.remove("menu-open"); }
    if (tommysMenu3 !== null) { tommysMenu3.classList.remove("menu-open"); }
    sideMenuInner.classList.remove("compact");
  
  if(accordionActive.classList.contains("active")) {
    accordionActive.classList.remove("active");
    setTimeout(function() {
      accordionActive.nextElementSibling.style.maxHeight = 0;
    }, 500);    
  }
}

if (burgerButton !== null) {
  burgerButton.addEventListener("click", sideMenu);  
}

let openMenu1 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.toggle("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem1 !== null) {
  menuItem1.addEventListener("click", openMenu1); 
}

let openMenu2 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.toggle("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem2 !== null) {
  menuItem2.addEventListener("click", openMenu2);
}

let openMenu3 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.toggle("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem3 !== null) {
  menuItem3.addEventListener("click", openMenu3);
}

let openMenu4 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.toggle("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem4 !== null) {
  menuItem4.addEventListener("click", openMenu4);
}

let openMenu5 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.toggle("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem5 !== null) {
  menuItem5.addEventListener("click", openMenu5);
}

let openMenu6 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.toggle("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem6 !== null) {
  menuItem6.addEventListener("click", openMenu6);
}

let openMenu7 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.toggle("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem7 !== null) {
  menuItem7.addEventListener("click", openMenu7);
}

let openMenu8 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.toggle("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem8 !== null) {
  menuItem8.addEventListener("click", openMenu8);
}

let openMenu9 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.toggle("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem9 !== null) {
  menuItem9.addEventListener("click", openMenu9);
}

let openMenu10 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.toggle("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem10!== null) {
  menuItem10.addEventListener("click", openMenu10);
}

let openMenu11 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.toggle("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.remove("menu-open"); }
};
if (menuItem11 !== null) {
  menuItem11.addEventListener("click", openMenu11);
}

let openMenu12 = () => {
  if (deepslideItem1 !== null) { deepslideItem1.classList.remove("menu-open"); }
  if (deepslideItem2 !== null) { deepslideItem2.classList.remove("menu-open"); }
  if (deepslideItem3 !== null) { deepslideItem3.classList.remove("menu-open"); }
  if (deepslideItem4 !== null) { deepslideItem4.classList.remove("menu-open"); }
  if (deepslideItem5 !== null) { deepslideItem5.classList.remove("menu-open"); }
  if (deepslideItem6 !== null) { deepslideItem6.classList.remove("menu-open"); }
  if (deepslideItem7 !== null) { deepslideItem7.classList.remove("menu-open"); }
  if (deepslideItem8 !== null) { deepslideItem8.classList.remove("menu-open"); }
  if (deepslideItem9 !== null) { deepslideItem9.classList.remove("menu-open"); }
  if (deepslideItem10 !== null) { deepslideItem10.classList.remove("menu-open"); }
  if (deepslideItem11 !== null) { deepslideItem11.classList.remove("menu-open"); }
  if (deepslideItem12 !== null) { deepslideItem12.classList.toggle("menu-open"); }
};
if (menuItem12!== null) {
  menuItem12.addEventListener("click", openMenu12);
}

let tommysMenuOpen1 = () => {
  if (tommysMenu1 !== null) { tommysMenu1.classList.toggle("menu-open"); }
  if (tommysMenu2 !== null) { tommysMenu2.classList.remove("menu-open"); }
  if (tommysMenu3 !== null) { tommysMenu3.classList.remove("menu-open"); }
};
if (tommysMenuItem1 !== null) {
  tommysMenuItem1.addEventListener("click", tommysMenuOpen1); 
}

let tommysMenuOpen2 = () => {
  if (tommysMenu1 !== null) { tommysMenu1.classList.remove("menu-open"); }
  if (tommysMenu2 !== null) { tommysMenu2.classList.toggle("menu-open"); }
  if (tommysMenu3 !== null) { tommysMenu3.classList.remove("menu-open"); }
};
if (tommysMenuItem2 !== null) {
  tommysMenuItem2.addEventListener("click", tommysMenuOpen2); 
}

let tommysMenuOpen3 = () => {
  if (tommysMenu1 !== null) { tommysMenu1.classList.remove("menu-open"); }
  if (tommysMenu2 !== null) { tommysMenu2.classList.remove("menu-open"); }
  if (tommysMenu3 !== null) { tommysMenu3.classList.toggle("menu-open"); }
};
if (tommysMenuItem3 !== null) {
  tommysMenuItem3.addEventListener("click", tommysMenuOpen3); 
}

/*
document.addEventListener('click', function handleClickOutsideBox(event) {

  const outsideSideMenu = !navbarSidePapa.contains(event.target);
  const outsideSideMenuBurger = !burgerButton.contains(event.target);

  if (outsideSideMenu && outsideSideMenuBurger) {
    navbarSidePapa.classList.remove("awake")
    body.classList.remove("awoken")
    justLikePapa.classList.remove("menu-open");
    fjallRavenMenu.classList.remove("menu-open");
    miirMenu.classList.remove("menu-open");
    primus.classList.remove("menu-open");
  }
});
*/

/*************************/
/******** Mobi Nav *******/
/*************************/

let mobiBurgerButton = document.querySelector(".mobi-ham-button");
let mobiMenu = document.querySelector("#mobiNav");
let mobiCartBtn = document.querySelector("#cart-bottom-bar");
let accordionTitle = document.querySelector(".accordion-menu-title");

let mobiPop = () => {
    mobiMenu.classList.toggle("mobi-awake")    
    body.classList.toggle("mobi-awoken")
  if(mobiMenu.classList.contains("mobi-awake")) {
    if(accordionTitle.classList.contains("dropdown")) {
    accordionActive.classList.remove("active");
      setTimeout(function() {
        accordionActive.nextElementSibling.style.maxHeight = 0;
      }, 500);   
    }
  }
  if (body.classList.contains("mobi-awoken")) {
    mobiSearchBtn.disabled = true;
    mobiCartBtn.disabled = true;
  } else {
    mobiSearchBtn.disabled = false;
    mobiCartBtn.disabled = false;
  }
}

mobiBurgerButton.addEventListener("click", mobiPop);

/**********************************/
/****** Accordion Child open ******/
/**********************************/

const accordionMenuTitle = document.querySelectorAll(".menu-accordion .accordion-menu-title.dropdown");  
const sideMenuInner = document.querySelector(".sidenav-inner");
const productAccordionTitle = document.querySelectorAll(".product-accordion .accordion-menu-title.dropdown");  

accordionMenuTitle.forEach(menuTitle => {
  menuTitle.addEventListener("click", event => {
    /* Only one open at a time */
    const activeAccordionMenu = document.querySelector(".menu-accordion .accordion-menu-title.dropdown.active");
    if(activeAccordionMenu && activeAccordionMenu !== menuTitle) {
      activeAccordionMenu.classList.toggle("active");
      activeAccordionMenu.nextElementSibling.style.maxHeight = 0;
    }
    /* Open and close */
    menuTitle.classList.toggle("active");
    
    const accordionMenuBody = menuTitle.nextElementSibling;
    if(menuTitle.classList.contains("active")) {
      accordionMenuBody.style.maxHeight = accordionMenuBody.scrollHeight + "px";
      sideMenuInner.classList.add("compact");
    } else {
      accordionMenuBody.style.maxHeight = 0;
      sideMenuInner.classList.remove("compact");
    }
  });
});

productAccordionTitle.forEach(productMenuTitle => {
  productMenuTitle.addEventListener("click", event => {
    /* Only one open at a time */
    const activeProductMenu = document.querySelector(".product-accordion .accordion-menu-title.dropdown.active");
    if(activeProductMenu && activeProductMenu !== productMenuTitle) {
      activeProductMenu.classList.toggle("active");
      activeProductMenu.nextElementSibling.style.maxHeight = 0;
    }
    /* Open and close */
    productMenuTitle.classList.toggle("active");
    
    const productMenuBody = productMenuTitle.nextElementSibling;
    if(productMenuTitle.classList.contains("active")) {
      productMenuBody.style.maxHeight = productMenuBody.scrollHeight + "px";
    } else {
      productMenuBody.style.maxHeight = 0;
    }
  });
});

/**********************************/
/**** Accordion Grandchild open ***/
/**********************************/
  const accordionLastLvl = document.querySelectorAll(".sidenav .accordion-menu-body-inner.dropdown-2");
  
  accordionLastLvl.forEach(menuLastLvl => {
    menuLastLvl.addEventListener("click", event => {
      
      /* Open and close */
      menuLastLvl.classList.toggle("active");
      const accordionGrandchild = menuLastLvl.nextElementSibling; /* .last-lvl-body */
      const accordionLastParent = menuLastLvl.parentElement; /* .accordion-menu-body */
      if(menuLastLvl.classList.contains("active")) {
        accordionGrandchild.style.maxHeight = accordionGrandchild.scrollHeight + "px";
        accordionLastParent.style.maxHeight = accordionLastParent.scrollHeight + accordionGrandchild.scrollHeight + "px";
      } else {
        accordionGrandchild.style.maxHeight = 0;
      }      
    });
  });


/**********************************/
/*********** Mobi Search **********/
/**********************************/

let mobiSearchBtn = document.querySelector(".bottom-search");
let searchFull = document.querySelector(".search_full-screen");
let mobiSearchOpen = document.querySelector(".bottom-search .icon-open");
let mobiSearchClose = document.querySelector(".bottom-search .icon-close");

let mobiSearchTrigger = () => {
  searchFull.classList.toggle("searching")
  body.classList.toggle("search-open")
  if (searchFull.classList.contains("searching")) {
    mobiSearchOpen.style.display = "none";
    mobiSearchClose.style.display = "block";
  } else {
    mobiSearchOpen.style.display = "block";
    mobiSearchClose.style.display = "none";
  }
  if (body.classList.contains("search-open")) {
    mobiBurgerButton.disabled = true;
    mobiCartBtn.disabled = true;
  } else {
    mobiBurgerButton.disabled = false;
    mobiCartBtn.disabled = false;
  }
}

mobiSearchBtn.addEventListener("click", mobiSearchTrigger);

/**********************************/
/********** Sticky Header *********/
/**********************************/

const headerNav = document.querySelector(".homepage-sticky");
const headerMenu = document.querySelector(".homepage-sticky .header-wrapper .list-menu");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;
 
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    return;
  }
 
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});


/**********************************/
/******** Footer Dropdowns ********/
/**********************************/

const aTitle = document.querySelectorAll(".footer-block__heading");  
const footerWrapper = document.querySelector(".footer_content-container");  

aTitle.forEach(aOpen => {
  aOpen.addEventListener("click", event => {
    /* Only one open at a time */
    const aBody = aOpen.nextElementSibling;
    /* Open and close */
    if (footerWrapper.classList.contains("drops")) {
      aOpen.classList.toggle("active");
      if(aOpen.classList.contains("active")) {
        aBody.style.maxHeight = aBody.scrollHeight + "px";                    
      } else {
        aBody.style.maxHeight = 0;
      }
    }
  });
});

if (footerWrapper !== null) {

  if (window.innerWidth < 750) {
    footerWrapper.classList.add("drops");
    footerWrapper.classList.remove("lines");
  } else {
    footerWrapper.classList.add("lines");
    footerWrapper.classList.remove("drops");
  }
  if (window.attachEvent) {
    window.addEventListener("onresize", event => {
      if (window.innerWidth < 750) {        
        footerWrapper.classList.add("drops");
        footerWrapper.classList.remove("lines");
      } else {
        footerWrapper.classList.add("lines");
        footerWrapper.classList.remove("drops");
      }
    });
  } else if (window.addEventListener) {
    window.addEventListener("resize", event => {
      if (window.innerWidth < 750) {
        footerWrapper.classList.add("drops");
        footerWrapper.classList.remove("lines");
      } else {
        footerWrapper.classList.add("lines");
        footerWrapper.classList.remove("drops");
      }
    });
  } 

}


/**********************************/
/******** Lazyload Effect *********/
/**********************************/

AOS.init({
  offset: 100,
  delay: 50,
  duration: 500,
  easing: 'ease-out',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
});

/*************************************/
/******** Local Time Display *********/
/*************************************/

/*
var timezone = document.getElementById('timezone-bar');

function time() {
  var d = new Date();
  var s = d.getSeconds();
  var m = d.getMinutes();
  var h = d.getHours();
  timezone.textContent = 
    ("0" + h).substr(-2) + ":" + ("0" + m).substr(-2) + ":" + ("0" + s).substr(-2);
  if (h > 16) {
    console.log("Day");
  }
}

setInterval(time, 1000);
*/

/************************************/
/******** Brand Page filter *********/
/************************************/

function filterSelection(c) {
  var x, i;
  x = document.getElementsByClassName("letter-category");
  if (c == "all") c = "";
  // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
  for (i = 0; i < x.length; i++) {
    w3RemoveClass(x[i], "show");
    if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show");
  }
}

// Show filtered elements
function w3AddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      element.className += " " + arr2[i];
    }
  }
}

// Hide elements that are not selected
function w3RemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);
    }
  }
  element.className = arr1.join(" ");
}



/**********************************************************/
/******** Delay typing animation until lazyloaded *********/
/**********************************************************/

const swiperTitle = document.querySelector(".swiper-collection_title");
const videoTitle = document.querySelector(".video-swipe .swiper-collection_title");

const observer = new IntersectionObserver(entries => {
  // Loop over the entries
  entries.forEach(entry => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      entry.target.classList.add('typing');
    }
  });
});

if (swiperTitle !== null) {
  observer.observe(swiperTitle);
}
if (videoTitle !== null) {
  observer.observe(videoTitle);
}

/**********************************************************/
/******************** Legal page tabs *********************/
/**********************************************************/

function openContent(evt, contentHead) {
  var i, tabcontent, tablinks;

  tabcontent = document.getElementsByClassName("legal-text");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  tablinks = document.getElementsByClassName("legal-btn");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  document.getElementById(contentHead).style.display = "block";
  evt.currentTarget.className += " active";
}

/******************************************************************/
/******************** Account create redirect *********************/
/******************************************************************/

 (function() { 
   var REDIRECT_PATH = '/account'; 
 
   var selector = '#create_customer, form[action$="/account"][method="post"]', 
       $form = document.querySelectorAll(selector)[0]; 
 
   if ($form) { 
     $redirect = document.createElement('input'); 
     $redirect.setAttribute('name', 'return_to'); 
     $redirect.setAttribute('type', 'hidden'); 
     $redirect.value = REDIRECT_PATH; 
     $form.appendChild($redirect); 
   } 
 })(); 
 

/******************************************************************/
/******************* Shipping day/time notice *********************/
/******************************************************************/

// Get current date and time
  var shipNow = new Date();
  var datetime = shipNow.toLocaleString();
  var shipTime = shipNow.getHours();
  var shipGreet;
  const daysOfWeek = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
  ];
  const dayOfWeek = daysOfWeek[shipNow.getDay()];

  if (dayOfWeek == 'Saturday' || dayOfWeek == 'Sunday') {
    shipGreet = 'Your order will be booked on Monday';
  } else {

    if (shipTime >= 0 && shipTime <= 14) {
      shipGreet = 'Your order will be shipped today';
    } else if (shipTime >= 15 && shipTime <= 23) {
      shipGreet = 'Your order will be shipped tomorrow';
    }
    
  }

  

  // Insert date and time into HTML
  document.getElementById("datetime").innerHTML = shipGreet;


